import {CommonModule} from "@angular/common";
import {Component, Input} from "@angular/core";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {Observable} from "rxjs";
import {
  IPushJobStatus,
  PushJobKind,
  pushJobNoun,
} from "../../../core/api/controllers/push-jobs/dto/push-job";
import {PushProgressService} from "../../../core/services/push-progress.service";

/** The floating progress button for one push kind. Mount one host per kind. */
@Component({
  selector: "app-push-progress-host",
  standalone: true,
  templateUrl: "./push-progress-host.component.html",
  styleUrls: ["./push-progress-host.component.scss"],
  imports: [CommonModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule],
})
export class PushProgressHostComponent {
  @Input() kind: PushJobKind = "Exercise";
  /** Position in the FAB stack, so two simultaneous pushes do not overlap. */
  @Input() slot = 0;

  get job$(): Observable<IPushJobStatus | null> {
    return this.progress.job$(this.kind);
  }

  constructor(public progress: PushProgressService) {}

  icon(job: IPushJobStatus): string {
    switch (job.status) {
      case "Completed": return "check";
      case "CompletedWithFailures": return "warning";
      case "Canceled": return "block";
      case "Interrupted": return "power_settings_new";
      case "Failed": return "error";
      default: return "sync";
    }
  }

  label(job: IPushJobStatus): string {
    const noun = pushJobNoun(job.kind ?? this.kind);
    if (!this.progress.isTerminal(job)) {
      return `${this.titleCase(noun)} push ${job.progressPercent}% complete. Open progress.`;
    }
    return `${this.titleCase(noun)} push ${job.status}. Open result.`;
  }

  open(): void {
    this.progress.openDialog(this.kind);
  }

  private titleCase(value: string): string {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
}
